import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Popupmsg from './Popupmsg';
import 'reactjs-popup/dist/index.css'
import { useNavigate, useLocation } from "react-router-dom";
import Volunteer_Navbar from './Volunteer_Navbar';
import Volunteer_Header from './Volunteer_Header';
import DataTable  from 'react-data-table-component';
import './Searchjob_seeker.css'
import LoadingSpinner from '../Utils/LoadingSpinner'
import { toast } from 'react-toastify';


function Searchjob_seeker() {
 // let jobfair_id = JSON.parse(volunteer)[0].V_jobfair;
  const [search_query, setsearch_query] = useState("");
  const [statusId, setstatusId] = useState();
  const location = useLocation();
  const navidate = useNavigate();
  const [filterText, setFilterText] = useState('');
  const [loader,setLoader] = useState(true);
  //======================= To store jobseeker details =============================

  const [jobseeker_details, setjobseeker_details] = useState([{
    "id": "",
    "jobseeker_regno": "",
    "JobfairID": "",
    "CompanyID": "",
    "status": "",
    "reporting_time": "",
    "volunteer": "",
    "updated_by": null,
    "jobdescription": null,
    "date": "",
    "jobseeker": ""
  },
  ]);
  //======================= To search any data of jobseeker in search bar =============================

  // const getjobseeker_search = () => {
  //   axios.post(`https://pl.aspireitacademy.com/Volntr_jobskr_search`, { search_query: filterText, jobfair_id: jobfair_id, id: id }
  //   ).then((response) => {
  //     // console.log(response.data);
  //     if (response.data.message == "No Data Found" ) {
  //       alert("No Data Found");
  //     }
  //     else {
  //       setjobseeker_details(response.data);
  //     }
  //   });
  // }
  //======================= To  list status in dropdown for update status  =============================

  const [status, setstatus] = useState([
    {
      "id": "",
      "status": "",
    }
  ]);
  // // add this useEffect to prevent going back to login page
  // useEffect(() => {
  //   const unlisten = history.listen((location) => {
  //     if (location.pathname === "/" && localStorage.getItem("isLoggedIn") !== "true") {
  //       // if the user is not logged in, navigate them back to the login page
  //       navidate("/login");
  //     }
  //   });
  //   return unlisten;
  // }, [history]);
  //======================= api for to  list status in dropdown for update status  =============================

  const getstatus = () => {
    const response = axios.get("https://pl.aspireitacademy.com/status_list").then((response) => {
      if (response.data == null) {
        alert("Enter correct keyword")
      }
      else {
        let index1 = -1;
        response.data.forEach((element, ind) => {
          if (element.status == 'Applied') {
            index1 = ind;
          }
        });
        if (index1 > -1) {
          response.data.splice(index1, 1);
        }
        index1 = -1;
        response.data.forEach((element, ind) => {
          if (element.status == 'New') {
            index1 = ind;
          }
        });
        if (index1 > -1) {
          response.data.splice(index1, 1)
        }
        setstatus(response.data);
      }

    }).catch(function (error) {
      toast.error("Something Went Wrong")  ;
      setLoader(false);
  })
  }

  //======================= api for getting jobseeker details display in table  =============================

  const getjobseeker_details = () => {
    const volunteer = localStorage.getItem("user");
    let id = JSON.parse(volunteer)[0].id;
    axios.get(`https://pl.aspireitacademy.com/Volntr_GET_jobskr/${id}`).then((response) => {
      if (response.data === null) {
        alert("No Results Found")
        setLoader(false);
      }
      else {
        setjobseeker_details(response.data);
        setLoader(false);
      }

    }).catch(function (error) {
      toast.error("Something Went Wrong")  ;
      setLoader(false);
  })
  }
  useEffect(() => {
    const volunteer = localStorage.getItem("user");  
    if (volunteer === null) {
      localStorage.removeItem("user");
      navidate('/Volunteer_login', {
        state: {
          user: volunteer,
        }
      });
      
    }
    else {
      getstatus();
      getjobseeker_details();
    }
  }, []);

  useEffect(() => {
    getRows()
  }, [jobseeker_details, filterText])


     //======================= api for  update jobseeker status by volunteer in table =============================

  const change_status = (row, statusid, index) => {
    const volunteer = localStorage.getItem("user");
    let id = JSON.parse(volunteer)[0].id;
    const response = axios.put(`https://pl.aspireitacademy.com/Volntr_update_jobskr_status/${row.id}`, {
      status: statusid,
      updated_by: id
    }).then((response) => {
      if (response && response.data && response.data[0]) {
        jobseeker_details[index] = response.data[0];
        setjobseeker_details([...jobseeker_details]);
      }
    }).catch(function (error) {
      toast.error("Something Went Wrong")  ;
      
      
  })
  }
  //=======================  show popup msg =============================
  const update_table = () => {
    getjobseeker_details();
  }
  const [showpopup, setshowpopup] = useState(false);
  const msg = () => {
    // console.log("insidemsg");
    setshowpopup(true);

  }
  
  //Data table structure
const customStyles = {
  headRow: {
    style: {
      color:'#fff',
      backgroundColor: '#a7a7c1',
      fontSize:"13px"
    },
  },
  rows: {
    style: {
      color: "#000",
      backgroundColor: "#fff"
    }
  },
  // cells: {
  //     style: {
  //        margin: '0px', // override the cell padding for data cells
  //         paddingRight: '0px',
  //     },
  // },
  
}
const formatDate = (time) => {
      let newDate = new Date(time);
      if (newDate == 'Invalid Date') {
        return time;
      }
      let minutes = newDate.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      let presentdate = (newDate.getHours() % 12 || 12) + ":" + minutes + (newDate.getHours() < 12 ? "AM" : "PM");
      return presentdate
    }
const columns = [
  {
      name: 'No',
      selector: row => row.no,
      width:"50px",
    
     
     
  },
  {
      name: 'RegNo',
      selector: row => row.jobseeker_regno,
      sortable: true,
      width:"90px",
     
      
  },
  {
    name: 'Name',
    selector: row => row.jobseeker,
    sortable: true,
    grow:2,
    width:"120px",
    
},
  {
      name: 'Job Fair',
      selector: row => row.JobfairID,
      sortable: true,
      grow:2,
     
      
  },
  {
      name: 'Reporting Time',
      selector: row => row.reporting_time,
      sortable: true,
      grow:2,
      width:"140px",
  },
  {
      name: 'Volunteer',
      selector: row => row.volunteer,
     
  },
  {
      name: ' Status',
      selector: row => row.status,
	  width:"170px",
     
  },
  {
      name: 'Update Status',
      selector: row => row.AppliedStatus,
    
     

  },
  {
    name: 'Updated By',
    selector: row => row.updated_by,
  
   

},
];

const [rows , setRows] = useState([]);
const getRows = ()=> {
  let res = [];
  let data = jobseeker_details;
  res = data.filter(
    item => 
    item.jobseeker_regno && item.jobseeker_regno .toLowerCase().includes(filterText.toLowerCase()) ||
    item.jobseeker && item.jobseeker .toLowerCase().includes(filterText.toLowerCase()) ||
    item.jobfairID && item.jobfairID .toLowerCase().includes(filterText.toLowerCase()) ||
    item.volunteer && item.volunteer .toLowerCase().includes(filterText.toLowerCase()) ||
    item.status && item.status.toLowerCase().includes(filterText.toLowerCase()) || 
    item.jobfairID && item.jobfairID .toLowerCase().includes(filterText.toLowerCase()) ||
    item.updated_by && item.updated_by .toLowerCase().includes(filterText.toLowerCase())
          )
          .map((item,index) => {
    
  let itemDate = formatDate(item.reporting_time); // convert date format
    var colors;
    if (item.status === "Applied") { colors = { color: "green" } }
    if (item.status === "Rejected") { colors = { color: "red" } }
    if (item.status === "Shortlisted") { colors = { color: "gray" } }  
    return({
        no : index+1 ,
        jobseeker_regno:item.jobseeker_regno,
        jobseeker:item.jobseeker,
        JobfairID:item.jobfairID,
        volunteer:item.volunteer,
        reporting_time: itemDate,
        status:
        <select onChange={(newvalue) => change_status(item, newvalue.target.value, index)} required>
        <option>--select--</option>
          {
            status.map((item => { return (<option value={item.id}>{item.status}</option>) }))
          }
        </select>      ,
        AppliedStatus: <span style={colors}>{item.status}</span>,
        updated_by : item.updated_by
    })
  
  })
  setRows(res);

}

  return (
    <div class="my-custom-scrollbar my-custom-scrollbar-primary">
      <section className="bg-white h-100 w-100">
        <div>
          <Volunteer_Header />
          <Volunteer_Navbar />
          { loader ? <LoadingSpinner />: 
          <div className="container" >
            <h4  className='text-start text-capitalize mt-4 ps-2 page-title'>Jobseeker details</h4>
            <hr className="search_line"></hr>
            
              <Popupmsg jobseeker_details={jobseeker_details} update_table={update_table} />
            
            <div className="table-responsive  px-1">
              <div className='input-box'>
                <div className='my-2 col-md-4 '>
                  <input type="search"
                    className="form-control w-100  fs-6"
                    placeholder='Search'
                    onChange={(e) => setFilterText(e.target.value)}
                    value={filterText} />
                </div>
              </div>
                        
                        <DataTable
                            
                            columns={columns}
                            data={rows} 
                            fixedHeader ={true} 
                            fixedHeaderScrollHeight="600px"
                            striped
                            customStyles={customStyles}  
                            persistTableHead
                            pagination
                            
                        />
                </div>
            {showpopup && <Popupmsg jobseeker_details={jobseeker_details} update_table={update_table} ></Popupmsg>}
          </div>
}
        </div>
      </section>
    </div>
  );
}
export default Searchjob_seeker;



